var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurgePricingAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#0065FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7363 10.3381L12.103 16.7047C11.9653 16.9402 11.9657 17.2317 12.104 17.4669C12.2423 17.702 12.4969 17.844 12.7696 17.8381H14.6763C14.9215 17.8363 15.1572 17.9324 15.3312 18.1052C15.5051 18.2779 15.603 18.5129 15.603 18.7581V21.1647C15.6052 21.4571 15.7977 21.7139 16.0777 21.798C16.3577 21.8822 16.6599 21.7741 16.823 21.5314L20.343 16.2514C20.497 16.0191 20.5115 15.7211 20.3808 15.4749C20.2501 15.2287 19.995 15.0739 19.7163 15.0714H17.903C17.3949 15.0714 16.983 14.6595 16.983 14.1514V10.6714C16.9851 10.3678 16.7818 10.1011 16.4885 10.0227C16.1952 9.94426 15.886 10.0739 15.7363 10.3381Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgePricingAct);
export default __webpack_public_path__ + "static/media/surgePricingAct.73fb9f77dcdc01cb7ea9880fef38493c.svg";
export { ForwardRef as ReactComponent };